export const FAUCET_URL = "https://aptoslabs.com/testnet-faucet";
export const NODE_URL = "https://fullnode.mainnet.aptoslabs.com/v1";
export const MODULE_ADDR = '0x1660c528ce8a8cb84207189cf26d5662cf82b4b86bb3d0d999bfe1d7dca18399';

export const RewardTokenList = {
    APT: '0x1::aptos_coin::AptosCoin',
    SNR: '0x1::aptos_coin::AptosCoin',
    USDC: '0x1::aptos_coin::AptosCoin',
}